"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _elementUi = require("element-ui");
var _login = require("@/api/login");
//
//
//
//
//
//
var _default = exports.default = {
  name: 'WxWorkLoginCallbackPane',
  //企业微信登录回调
  data: function data() {
    return {
      authLoginData: {
        code: null,
        appId: null,
        state: null
      },
      loadingInstance: null
    };
  },
  created: function created() {
    this.loadingInstance = _elementUi.Loading.service({
      target: '#wx_work_login_callback',
      text: "登录中，请耐心等待"
    });
  },
  mounted: function mounted() {
    //获取queryString 参数
    this.authLoginData.code = this.$route.query.code;
    this.authLoginData.state = this.$route.query.state;
    this.authLoginData.appId = this.$route.query.appid;
    console.log(this.authLoginData);
    this.authLogin();
  },
  methods: {
    authLogin: function authLogin() {
      var _this = this;
      this.$store.dispatch("user/wxWorkLogin", this.authLoginData).then(function () {
        if (_this.loadingInstance) {
          _this.loadingInstance.close();
        }
        _this.$router.push({
          path: "/"
        });
      }).catch(function () {
        if (_this.loadingInstance) {
          _this.loadingInstance.close();
        }
        _this.$router.push({
          path: "/login"
        });
      });
    }
  }
};